<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('document', ['fileObj']),
    ...mapState('system', ['routerStatusRedirect']),
    ...mapState('contract', ['limitTransaction']),
  },
  async created() {
    if (!this.fileObj) {
      await this.getDocuments()
    }

    if (!this.limitTransaction) {
      await this.getLimitTransaction()
    }
    const limitTransaction2 = await this.getContractsAgreementsMyfinbizService()

    console.log('this.limitTransaction', this.limitTransaction)
    console.log('limitTransaction2', limitTransaction2)    

    // truthOrFalsehoodOfCertificateOfIncomeAmount
    console.log(`status check ${this.resultName}`)
    if (
      // this.fileObj?.certificateOfIncomeAmount &&  // 소득금액증명 안했다고 계약석 작성화면을 안보여주면 유저가 갈 곳이 없다
      (!this.limitTransaction?.isAgreed || !limitTransaction2?.isAgreed)
    ) {
      const name = 'signup/limit-transaction'
      if ([name].includes(this.$route.name) === false && this.routerStatusRedirect) {
        return await this.$router.replace({ name })
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('document', ['getDocuments']),
    ...mapActions('contract', ['getLimitTransaction']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),
  },
}
</script>
